import { useRecoilValue } from 'recoil'
import { UserTier } from 'src/common-services'

import { meetsTier } from 'src/atoms/user'
import { isLocationFree } from 'src/atoms/search'

export const useLocationUnlocked = (tier?: UserTier) => {
  const _meetsTier = useRecoilValue(meetsTier(tier))
  const _isLocationFree = useRecoilValue(isLocationFree)

  // Show as unlocked if the user does not meet the tier and the location is free
  if (!_meetsTier && _isLocationFree) {
    return true
  }
  return false
}
